import { useQuery } from "@tanstack/react-query";
import { clientVisitService } from "../../api/clientVisitService";
import { getEmployeeId } from "../../utils/session";
import { CLIENT_VISIT_OPTIONS_KEY } from "./clientVisitUtils";

/** { canFile, clients } for the signed-in employee (sidebar item and the form). */
const useClientVisitOptions = () =>
  useQuery({
    queryKey: [CLIENT_VISIT_OPTIONS_KEY],
    queryFn: () => clientVisitService.getOptions(),
    enabled: !!getEmployeeId(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

export default useClientVisitOptions;
